import { render } from "./SupportView.vue?vue&type=template&id=5d0ee34c&scoped=true"
import script from "./SupportView.vue?vue&type=script&lang=js"
export * from "./SupportView.vue?vue&type=script&lang=js"

import "./SupportView.vue?vue&type=style&index=0&id=5d0ee34c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d0ee34c"]])

export default __exports__